<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Редактировать дом
    </h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'building-details', params: { building_id: building.id }}">← Назад к Деталям дома</router-link>
    </div>

    <div class="text-right">
      <a v-if="building.id" class="red" href="#" @click.prevent="deleteBuilding">удалить дом</a>
    </div>

    <building-edit-form
      :building="building"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import helpers from '@/helpers'
import { getBuilding, deleteBuilding } from '@/services/building.service'
import buildingEditForm from '@/components/forms/building/BuildingEditForm'

export default {
  name: 'building-edit',
  components: { buildingEditForm },
  data () {
    return {
      building: {
        id: null,
        number: '',
        contract_number_prefixes: '',
        full_name: '',
        address: ''
      },

      errors: {
        building: {
          id: [],
          number: [],
          contract_number_prefixes: [],
          address: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.building_id !== undefined) {
      this.building.id = this.$route.params.building_id

      getBuilding(this.building.id).then((response) => {
        this.building = response.data
      })
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,
    deleteBuilding () {
      deleteBuilding(this.building.id).then((response) => {
        this.showMsg('Дом был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'address-details', params: { address_id: this.$route.params.address_id } })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Дом был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'address-details', params: { address_id: this.$route.params.address_id } })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }

  }
}
</script>


// WEBPACK FOOTER //
// BuildingEdit.vue?9ffd0352